import { render, staticRenderFns } from "./SwitchWithDescription.vue?vue&type=template&id=739190b2&scoped=true"
import script from "./SwitchWithDescription.vue?vue&type=script&lang=js"
export * from "./SwitchWithDescription.vue?vue&type=script&lang=js"
import style0 from "./SwitchWithDescription.vue?vue&type=style&index=0&id=739190b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739190b2",
  null
  
)

export default component.exports